import "./lp.css";
import { track } from "./analytics";
import { iconMarkup } from "./icons";

const brandIcons = {
  x: "x",
  threads: "threads",
  line: "line",
} as const;

for (const element of document.querySelectorAll<HTMLElement>("[data-brand-icon]")) {
  const name = element.dataset.brandIcon;
  if (name === "x" || name === "threads" || name === "line") {
    element.innerHTML = iconMarkup(brandIcons[name], "lp-share-icon");
  }
}

const header = document.querySelector<HTMLElement>("[data-lp-header]");
const syncHeader = (): void => {
  header?.classList.toggle("is-scrolled", window.scrollY > 12);
};

syncHeader();
window.addEventListener("scroll", syncHeader, { passive: true });

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const revealTargets = document.querySelectorAll<HTMLElement>("[data-reveal]");

if (reduceMotion || !("IntersectionObserver" in window)) {
  for (const target of revealTargets) target.classList.add("is-visible");
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: "0px 0px -10%", threshold: 0.14 },
  );
  for (const target of revealTargets) observer.observe(target);
}

for (const cta of document.querySelectorAll<HTMLAnchorElement>("[data-lp-cta]")) {
  cta.addEventListener("click", () => {
    track("lp_cta_click", { placement: cta.dataset.lpCta ?? "unknown" });
  });
}

track("lp_view");
